import { gql } from '@apollo/client'

export const GET_DEVICE_REPORT_PDF = gql`
  query getDeviceReportPdf($id: String, $fileName: String) {
    getDeviceReportPdf(id: $id, fileName: $fileName) {
      fileData
      fileName
    }
  }
`
